import React from 'react';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';

const DEFAULT_HITS_PER_PAGE_OPTIONS = [36, 72, 100];

type HitsPerPageControlProps = {
  searchTerm?: string;
  currentValue: number;
  onSelect: (value: number) => void;
  options?: Array<number>;
};

const HitsPerPageControl = ({
  searchTerm,
  currentValue,
  onSelect,
  options = DEFAULT_HITS_PER_PAGE_OPTIONS,
}: HitsPerPageControlProps) => {
  const trackHitsPerPageClick = (value: number) => {
    window.dataLayer.push({
      event: 'custom.hitsPerPage.set',
      value,
    });
    pushToDataLayer({
      event: 'select_page_size',
      search_type: 'site search',
      filter_name: 'show',
      filter_value: String(value),
      search_term: searchTerm,
    });
  };

  return (
    <div className="page-size-container">
      <ul className="page-size-list">
        <li>
          <span>Show:</span>&nbsp;&nbsp;
        </li>
        {options.map(value => (
          <li key={value}>
            <a
              href="#"
              style={{ fontWeight: currentValue === value ? 'bold' : '' }}
              onClick={e => {
                e.preventDefault();
                onSelect(value);
                trackHitsPerPageClick(value);
              }}
            >
              {value}
            </a>
            &nbsp;&nbsp;
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HitsPerPageControl;
